import { FulfillmentCutoffScheduleParser } from "@redotech/redo-model/checkouts/fulfillment-cutoff";
import * as z from "zod/v4";

export const getFulfillmentCutoffSchedule = {
  name: "getFulfillmentCutoffSchedule" as const,
  input: z.null(),
  output: z.object({ schedule: FulfillmentCutoffScheduleParser.optional() }),
};
